import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
//Limitless imports
import SimpleCard from "../../cards/simple-card/SimpleCard";
const useStyles = makeStyles(theme => ({
  buttonRoot: {
    padding: 0,
    borderRadius: 0,
    backgroundColor: theme.background.paper,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.03)"
    }
  },
  buttonSelected: {
    backgroundColor: "rgba(0, 0, 0, 0.08)"
  }
}));
const SimpleCardButton = ({
  selected,
  containerClass,
  disabled,
  onClick,
  id,
  ...rest
}) => {
  const classes = useStyles();
  const handleButtonClick = () => {
    if (!selected && typeof onClick === "function") {
      onClick();
    }
  };
  return /*#__PURE__*/React.createElement(Button, {
    className: `${selected ? classes.buttonSelected : ""} ${containerClass}`,
    classes: {
      root: classes.buttonRoot
    },
    onClick: handleButtonClick,
    disabled: disabled,
    id: rest.title
  }, /*#__PURE__*/React.createElement(SimpleCard, rest));
};
export default SimpleCardButton;
SimpleCardButton.propTypes = {
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  containerClass: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string
};
SimpleCardButton.defaultProps = {
  selected: false,
  multiline: false,
  containerClass: "",
  disabled: false
};